import React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Navigate, useNavigate } from "react-router-dom";
import "../../../index.css";

const CustomerList = () => {
  const products = [];
  const navigate = useNavigate();
  const columns = [
    {
      field: "ProductName",
      title: "Company Name",
      show: true,
      width: 350,
      filterable: true,
    },
    {
      field: "ProductName",
      title: "Address",
      show: true,
      width: 400,
      filterable: true,
    },
    {
      field: "ProductID",
      title: "Country",
      show: true,
      width: 230,
      filterable: true,
    },
    {
      field: "Category.CategoryName",
      title: "Bussiness Category",
      show: true,
      width: 250,
      filterable: true,
    },
    {
      field: "UnitPrice",
      title: "Status",
      show: true,
      width: 110,
      filterable: true,
    },
    {
      field: "UnitsInStock",
      title: "Actions",
      show: true,
      width: 100,
      filterable: true,
    },
  ];
  const [stateColumns, setStateColumns] = React.useState(columns);

  return (
    <div className="flex flex-col text-white px-14 py-7 bg-neutral-900 h-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-5">
          <div className="flex text-xs font-medium gap-3 items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
            <label>Settings</label>
          </div>
          <hr className="rotate-90 w-10 h-1 border-zinc-800"></hr>
          <label className="text-zinc-600 text-sm font-medium">
            Customer Master
          </label>
          <div>
            <form>
              <div className="relative bg-gray-900 w-80 h-9 rounded-lg border-zinc-800">
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 text-neutral-700"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    ></path>
                  </svg>
                </div>
                <input
                  type="search"
                  id="default-search"
                  className="block h-full pl-10 w-full text-sm font-normal bg-inherit text-white placeholder:text-white rounded-lg"
                  placeholder="Search Customer"
                  required
                />
              </div>
            </form>
          </div>
        </div>
        <div className="flex">
          <button
            className="flex text-sm font-medium h-9 w-48 bg-indigo-700 rounded-4xl justify-center items-center gap-2 leading-4"
            type="button"
            onClick={() => navigate("/customerform")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Add New Customer
          </button>
        </div>
      </div>
      <div className="h-5/6 mt-4 w-full mb-16">
        <Grid
          style={{
            height: "100%",
            width: "100%",
            backgroundColor: "#181921",
            borderRadius: "15px",
            textAlign: "justify",
          }}
          data={products}
        >
          {stateColumns.map(
            (column, idx) =>
              column.show && (
                <GridColumn
                  key={idx}
                  field={column.field}
                  title={column.title}
                  filterable={column.filterable}
                  cell={column.cell}
                  width={column.width}
                  className="product-name"
                />
              )
          )}
        </Grid>
        <br />
      </div>
    </div>
  );
};

export default CustomerList;
